import React from "react"
import { paginate } from "../pagination/paginate"
import Pagination from "../pagination/Pagination"
import CalculateGITabContentStyle from "./CalculateGITabContentStyle.module.css"
import translate, { keys } from "../../../../../translation/translator"

const CalculateGiTabContent = ({
  data,
  pageSize,
  currentPage,
  goToLastPage,
  goToFirstPage,
  handlePageChange,
  paginationNextPage,
  paginationPrevPage,
  locale,
  calculateRangeSlider,
}) => {
  const paginateTab = paginate(data, currentPage, pageSize)
  return (
    <>
      {
        <React.Fragment>
          {" "}
          {data.length > 0 ? (
            <div id="table" className={CalculateGITabContentStyle.holder}>
              {calculateRangeSlider === true ? (
                <React.Fragment>
                  {" "}
                  <table className={CalculateGITabContentStyle.table}>
                    {" "}
                    <tr>
                      <th>{translate(keys.FOOD_DRINK, locale)}</th>
                      <th>
                        {translate(keys.GI, locale)}
                        <br />
                        <span>( {translate(keys.GLUCOSE, locale)} = 100)</span>
                      </th>
                      <th>
                        {translate(keys.PORTION, locale)} <br />
                        <span>{translate(keys.GRAM, locale)}</span>
                      </th>
                      <th>
                        {translate(keys.CARBOHYDRATES, locale)} <br />
                        <span>
                          {translate(keys.GRAM, locale)}/
                          {translate(keys.PORTION, locale)}
                        </span>
                      </th>
                      <th>
                        {translate(keys.GL, locale)}
                        <br />
                        <span>{translate(keys.PORTION, locale)}</span>
                      </th>
                    </tr>
                    <tbody>
                      {paginateTab.map(item => {
                        return (
                          <tr key={item._id}>
                            <td>{item.name}</td>
                            {item.giSE === 0 ? (
                              <td>{item.giMean}</td>
                            ) : (
                              <td>
                                {item.giMean} ± {item.giSE}
                              </td>
                            )}
                            <td>{item.serveSize}</td>
                            <td>{item.carbsForServeSize}</td>
                            <td>{item.glPerServe}</td>
                          </tr>
                        )
                      })}
                    </tbody>
                  </table>
                  {data.length > 0 ? (
                    <Pagination
                      pageSize={pageSize}
                      itemsCount={data.length}
                      currentPage={currentPage}
                      goToLastPage={goToLastPage}
                      goToFirstPage={goToFirstPage}
                      onPageChange={handlePageChange}
                      paginationNextPage={paginationNextPage}
                      paginationPrevPage={paginationPrevPage}
                    />
                  ) : (
                    <div>Няма резултати</div>
                  )}
                </React.Fragment>
              ) : null}
            </div>
          ) : (
            <p className="no-results">Няма резултати</p>
          )}
        </React.Fragment>
      }
    </>
  )
}

export default CalculateGiTabContent
